import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
      textAlign="center"
      p="20px"
    >
      
      <Typography
        fontWeight={700}
        color="#FF2625"
        sx={{
          fontSize: { lg: '180px', xs: '100px' },
          opacity: 0.15,
          lineHeight: 1,
          userSelect: 'none',
        }}
      >
        404
      </Typography>

      
      <Box mt="-60px">
        <Typography
          fontWeight={700}
          sx={{ fontSize: { lg: '44px', xs: '28px' } }}
          mb="16px"
        >
          Page Not Found
        </Typography>
        <Typography
          fontFamily="Alegreya"
          fontSize="20px"
          color="text.secondary"
          mb="40px"
        >
          Looks like this exercise doesn't exist in our gym. <br />
          Let's get you back on track!
        </Typography>

        <Button
          onClick={() => navigate('/')}
          sx={{
            bgcolor: '#FF2625',
            color: '#fff',
            fontSize: '18px',
            px: '40px',
            py: '12px',
            borderRadius: '4px',
            textTransform: 'none',
            '&:hover': { bgcolor: '#cc1f1e' },
          }}
        >
          Back to Home
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;